import { Environment } from "./environment.model";

export const environment: Environment = {
  fulcrumUrl: "https://portal.staging.momentumedge.com",
  wwwUrl: "https://staging.momentumedge.com",
  agentiumUrl: "https://agentium.com",
  claimItApiUsername: "F0B302EC-6C44-42F5-A606-3E82786D49E0",
  claimItApiPassword: "",
  insuredBetterUrl: "https://www.staging.insuredbetter.com",
  insuranceDirectoryUrl: "https://www.staging.insurancedirectory.com",
  momentumEdgeUrl: "https://staging.momentumedge.com",
  keycloakUrl: "https://auth.staging.momentumedge.com",
  keycloakRealm: "MomentumEdge",
  keycloakClientId: "advantage-console"
};
